// extracted by mini-css-extract-plugin
module.exports = {"container":"HeadingText_theme2_container__KN23H","heading":"HeadingText_theme2_heading__q2ksz","text":"HeadingText_theme2_text__ymCO_"};